import { ApiService } from '@/shared/api/ApiService';

import { type ShareData } from './types';

export const getShareMessageId = async (
  data: ShareData,
  standaloneBot?: string | null
) => {
  const payload = standaloneBot ? { ...data, standaloneBot } : data;

  return ApiService.instance.post<string>('v1/share', payload).then((res) => res.data);
};
